import { useRef } from "react";
import * as Scrivito from "scrivito";

Scrivito.provideComponent(
  "VideoWidget",
  Scrivito.connect(({ widget }) => {
    const videoRef = useRef();
    const language = widget.obj().language() || "de";
    // const [progressSent, setProgressSent] = useState({});

    const video = widget.get("video");
    if (!video) {
      return <div className="alert alert-info">No video selected.</div>;
    }

    const videoUrl = Scrivito.urlFor(video);
    if (!videoUrl) {
      return "Loading ...";
    }

    const poster = widget.get("poster");
    const posterUrl = poster ? Scrivito.urlFor(poster) : undefined;

    const captionTrack = widget.get("captionTrack");
    const descriptionTrack = widget.get("descriptionTrack");
    const captionTrackUrl = captionTrack && Scrivito.urlFor(captionTrack);
    const descriptionTrackUrl =
      descriptionTrack && Scrivito.urlFor(descriptionTrack);

    // const handlePlay = () => {
    //   if (window._paq || !Scrivito.isEditorLoggedIn()) {
    //     window._paq.push([
    //       "trackEvent",
    //       "Video",
    //       "play",
    //       video.get("blob").filename() || "Unnamed video",
    //     ]);
    //   }
    // };

    // const handleTimeUpdate = () => {
    //   if (!videoRef.current || !window._paq || Scrivito.isEditorLoggedIn()) {
    //     return;
    //   }

    //   const { duration } = videoRef.current;
    //   const { currentTime } = videoRef.current;
    //   const milestones = [0.25, 0.5, 0.75, 1]; // 25%, 50%, 75%, 100%

    //   milestones.forEach((m) => {
    //     if (currentTime / duration >= m && !progressSent[m]) {
    //       window._paq?.push([
    //         "trackEvent",
    //         "Video",
    //         `progress ${m * 100}%`,
    //         video.get("title") || "Unnamed video",
    //       ]);

    //       setProgressSent((prev) => ({ ...prev, [m]: true }));
    //     }
    //   });
    // };

    return (
      <Scrivito.ContentTag
        ref={videoRef}
        tag="video"
        src={videoUrl}
        content={widget}
        attribute="video"
        poster={posterUrl}
        controls
        width="100%"
        autoPlay={widget.get("autoplay")}
        loop={widget.get("loop")}
        muted={widget.get("muted")}
        playsInline
        // onPlay={handlePlay}
        // onTimeUpdate={handleTimeUpdate}
      >
        {captionTrack && (
          <track
            kind="captions"
            src={captionTrackUrl}
            srcLang={language}
            label={language.toUpperCase()}
          />
        )}{" "}
        {descriptionTrack && (
          <track
            kind="descriptions"
            src={descriptionTrackUrl}
            srcLang={language}
            label={language === "de" ? "Beschreibung" : "Description"}
          />
        )}{" "}
        Your browser does not support the video tag.
      </Scrivito.ContentTag>
    );
  })
);
